export default function SuccessSubmission() {
  return (
    <svg width="33.33" height="33.33" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.0023 19.9997L12.8808 14.0651C11.8227 13.1834 11.2937 12.7425 10.9133 12.2021C10.5764 11.7232 10.3261 11.1889 10.174 10.6235C10.0023 9.98532 10.0023 9.29666 10.0023 7.91934V3.33301M20.0023 19.9997L27.1238 14.0651C28.1818 13.1834 28.7109 12.7425 29.0912 12.2021C29.4282 11.7232 29.6785 11.1889 29.8306 10.6235C30.0023 9.98532 30.0023 9.29666 30.0023 7.91934V3.33301M20.0023 19.9997L12.8808 25.9342C11.8227 26.816 11.2937 27.2568 10.9133 27.7973C10.5764 28.2761 10.3261 28.8104 10.174 29.3759C10.0023 30.014 10.0023 30.7027 10.0023 32.08V36.6663M20.0023 19.9997L27.1238 25.9342C28.1818 26.816 28.7109 27.2568 29.0912 27.7973C29.4282 28.2761 29.6785 28.8104 29.8306 29.3759C30.0023 30.014 30.0023 30.7027 30.0023 32.08V36.6663M6.66895 3.33301H33.3356M6.66895 36.6663H33.3356"
        stroke="#B91D7B"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
